<template>
  <div class="filter-wrapper" :style="filterStyle">
    <Dropdown v-model="dropdownValue" name="filterDropdown" :options="dropdownOptions" :label="filterProps.title" @change="applyFilter" />
  </div>
</template>

<script setup>
import { computed, ref, watch, onUnmounted } from 'vue';
import Dropdown from '@atomic-ui/dropdown/Dropdown';

const props = defineProps({
  width: {
    type: String,
    default: '',
  },
  filterProps: {
    type: Object,
    required: true,
  },
});
const emit = defineEmits(['apply-filter']);
const dropdownValue = ref(null);

watch(
  () => props.filterProps.default,
  (newDefault) => {
    const hasDefault = typeof newDefault === 'number';
    const defaultValue = hasDefault ? (newDefault + 1).toString() : null;

    if (hasDefault && (!dropdownValue.value || dropdownValue.value !== defaultValue)) {
      dropdownValue.value = defaultValue;
    }
  },
  { immediate: true },
);

const dropdownOptions = computed(() => {
  const options = (props.filterProps?.options ?? []).map((o) => ({
    value: o.value,
    displayValue: o.text,
  }));

  return props.filterProps?.default === false ? [{ value: 'invalid', displayValue: 'Select one', disabled: true }, ...options] : options;
});

const filterStyle = computed(() => (props.width ? `width: ${props.width};` : null));

onUnmounted(() => {
  dropdownValue.value = null;
});

const applyFilter = () => {
  emit('apply-filter', dropdownValue.value);
};
</script>
